import { usePricelistChannelMarkupsQuery } from "@/generated/graphql";
import { useCallback, useMemo } from "react";

export const usePricelistChannelMarkups = (pricelistID?: string) => {
	// urql re-executes whenever context changes identity, so an inline object loops the render.
	const context = useMemo(() => ({ suspense: false }), []);
	const [{ data, error, fetching }, fetch] = usePricelistChannelMarkupsQuery({
		variables: { pricelistID },
		pause: !pricelistID,
		requestPolicy: "network-only",
		context,
	});

	const load = useCallback(() => {
		fetch();
	}, [fetch]);

	return {
		data,
		error,
		fetching,
		load,
	};
};
